// extracted by mini-css-extract-plugin
module.exports = {"selected-link":"styles_selected-link__96Gqc","link":"styles_link__Uepi1"};